import * as React from 'react';
import { DemandRequestModal } from '../../../../components/Recommendations';
import { DEMAND_MODAL_TITLE, EDemandModalText, EDemandRequestStep } from '../../constants';
import { ChoseDealTypeContainer } from '../ChoseDealTypeContainer';
import { PhoneVerificationContainer } from '../PhoneVerificationContainer';

export interface IDemandRequestModalContainerProps {
  steps: EDemandRequestStep[];

  onClose(): void;
  onSubmit(): void;
}

export const DemandRequestModalContainer: React.FC<IDemandRequestModalContainerProps> = props => {
  const { onClose, onSubmit, steps } = props;

  const [currentDemandStepIndex, setCurrentDemandStepIndex] = React.useState(0);
  const currentDemandStep = steps[currentDemandStepIndex];

  const isLastStep = currentDemandStepIndex === steps.length - 1;
  const submitText = isLastStep ? EDemandModalText.SEND : EDemandModalText.NEXT;

  const handleStepSubmit = React.useCallback(() => {
    if (!isLastStep) {
      setCurrentDemandStepIndex(stepIndex => stepIndex + 1);
    } else {
      onSubmit();
    }
  }, [onSubmit, isLastStep]);

  return (
    <DemandRequestModal title={DEMAND_MODAL_TITLE[currentDemandStep]} onClose={onClose} isOpen>
      {currentDemandStep === EDemandRequestStep.DEAL_TYPE && (
        <ChoseDealTypeContainer submitText={submitText} onSubmit={handleStepSubmit} />
      )}
      {currentDemandStep === EDemandRequestStep.PHONE && (
        <PhoneVerificationContainer submitText={submitText} onSubmit={handleStepSubmit} />
      )}
    </DemandRequestModal>
  );
};

DemandRequestModalContainer.displayName = 'DemandRequestModalContainer';
